import { useMutation } from '@tanstack/react-query';

import type {
  BookingSettingsFormData,
  MutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useBookingSettingsFormMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: BookingSettingsFormData }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
